<template>
  <page-view :is-loading="isLoading">
    <template #header>
      <base-header
        :title="pageTitle"
        :subtitle="video.title"
        has-intro
        @title="handleBackToListing"
        @back="handleBackToListing"
      >
        <template #info>
          <template v-if="isExternalSourceVideo">
            <v-chip
              class="external-chip ma-0 mr-3"
              dense
              @click="handleGoToLink(video.video_url)"
            >
              <v-icon left> mdi-link </v-icon>
              {{ getExternalLabelValue(video).replace('www.', '') }}
            </v-chip>
          </template>
          <span v-html="infoPage" />
        </template>
        <template #actions>
          <!-- dataBeingReplicated -->
          <template v-if="dataBeingReplicated">
            <small id="update-changes" style="font-size: 10px">
              {{ $t('message.pages.video.publishChanges') }}
            </small>
            <v-tooltip bottom>
              <template style="width: 20px" v-slot:activator="{ on, attrs }">
                <lottie-player
                  src="https://assets7.lottiefiles.com/packages/lf20_etdxgjzy.json"
                  background="transparent"
                  speed="0.8"
                  style="width: unset; height: unset; max-width: 30px"
                  class="ma-2 mr-0"
                  loop
                  autoplay
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <span>
                {{ $t('message.pages.video.dataBeingReplicated') }}
              </span>
            </v-tooltip>
          </template>
          <base-btn
            v-if="!isExternalSourceVideo"
            :data-intro="$t('message.introJS.common.hls')"
            type="tertiary"
            icon="mdi-link-variant"
            @click="
              showLink(),
                handleSnackbar($t('message.hlsCopiedLink')),
                handleShowLink(video.video_hls)
            "
          />
          <base-btn
            :data-intro="$t('message.introJS.common.performance')"
            type="secondary"
            @click="
              showPerformance(),
                handleSnackbar($t('message.pages.video.clipboardPerformance')),
                handleShowLink(textMetadata)
            "
          >
            Performance
          </base-btn>
          <base-btn
            :data-intro="$t('message.introJS.common.embed')"
            @click="showEmbed"
            :disabled="isExternalSourceNoLengthVideo && loadingExternalDuration"
            :loading="isExternalSourceNoLengthVideo && loadingExternalDuration"
          >
            Embed
          </base-btn>
          <base-btn
            type="tertiary"
            icon="mdi-dots-vertical"
            @click="showDots"
          />
        </template>
      </base-header>
    </template>

    <template #content>
      <!-- content -->
      <v-row no-gutters>
        <v-col cols="12">
          <v-card width="100%" height="100%" flat class="rounded-lg">
            <v-row no-gutters>
              <v-col :cols="isMobileBreakpoint ? '12' : '6'">
                <v-row>
                  <v-col
                    ref="player"
                    cols="12"
                    :class="isMobileBreakpoint ? '' : 'pr-10'"
                    :data-intro="$t('message.introJS.videoPage.preview')"
                    class="pb-0"
                  >
                    <v-card
                      v-if="
                        (video.status === 'CONVERTING' ||
                          video.status === 'FAILED' ||
                          video.status === 'DRAFT') &&
                        video.playable === false
                      "
                      class="d-flex flex-column justify-center align-center"
                      height="415px"
                      max-width="740px"
                    >
                      <template v-if="video.status === 'FAILED'">
                        <v-row align="center" justify="center">
                          <span class="red--text text-subtitle-1">
                            <v-icon size="20" color="red">
                              mdi-alert-circle-outline
                            </v-icon>
                            {{ $t('message.processingError') }}
                          </span>
                        </v-row>
                      </template>
                      <template v-else-if="isConvertingTooLazy">
                        <v-row>
                          <v-col cols="12" class="d-flex justify-center pb-0">
                            <lottie-player
                              src="https://assets4.lottiefiles.com/packages/lf20_edkrhqwp.json"
                              background="transparent"
                              speed="0.8"
                              style="
                                width: 200px;
                                transform: translate(0px, 12px);
                              "
                              class="ma-2 mr-0"
                              loop
                              autoplay
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            class="d-flex justify-center pa-0 pb-2"
                          >
                            <span class="text-center" style="font-size: 12px">
                              {{
                                $t(
                                  'message.pages.videoEditModal.videoConvertingText2'
                                )
                              }}
                              <br />
                              {{
                                $t(
                                  'message.pages.videoEditModal.videoConvertingText3'
                                )
                              }}
                            </span>
                          </v-col>
                        </v-row>
                      </template>
                      <template v-else>
                        <v-row>
                          <v-col cols="12" class="d-flex justify-center pb-0">
                            <lottie-player
                              src="https://assets4.lottiefiles.com/packages/lf20_edkrhqwp.json"
                              background="transparent"
                              speed="0.8"
                              style="
                                width: 200px;
                                transform: translate(0px, 12px);
                              "
                              class="ma-2 mr-0"
                              loop
                              autoplay
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            class="d-flex justify-center pa-0 pb-2"
                          >
                            <span class="text-center">
                              {{
                                video.playable
                                  ? $t(
                                      'message.pages.videoEditModal.videoConvertingText4'
                                    )
                                  : $t(
                                      'message.pages.videoEditModal.videoConvertingText'
                                    )
                              }}...
                            </span>
                          </v-col>
                        </v-row>
                      </template>
                    </v-card>
                    <v-card flat v-else>
                      <v-card
                        v-if="!isLandscapeOrientation"
                        style="margin: 0 auto"
                        flat
                        max-width="calc((100vh - 5rem) / 1.77778)"
                      >
                        <template v-if="konva.file && konva.img.image">
                          <div class="konva__container">
                            <v-stage
                              ref="stage"
                              class="konva__stage"
                              :config="konva.stage"
                              @mousedown="updateTransformer"
                              @touchstart="updateTransformer"
                            >
                              <v-layer ref="layer">
                                <v-image
                                  :config="konva.img"
                                  @dragend="handleTransformEnd"
                                  @transformend="handleTransformEnd"
                                />
                                <v-transformer ref="transformer" />
                              </v-layer>
                            </v-stage>
                            <span
                              class="konva__player"
                              v-html="embedPage()"
                              v-if="!isExternalSourceVideo"
                            />
                            <div
                              class="konva__player"
                              :id="`pandaexternal-${video.video_external_id}`"
                              v-else
                              v-html="embedPage()"
                            ></div>
                          </div>
                        </template>
                        <span
                          v-else-if="!isExternalSourceVideo"
                          v-html="embedPage()"
                        />
                        <div
                          class="konva__player"
                          :id="`pandaexternal-${video.video_external_id}`"
                          v-else
                          v-html="embedPage()"
                        ></div>
                      </v-card>
                      <span v-else-if="errors.videoDoesNotExist">
                        <v-card
                          class="d-flex flex-column justify-center align-center"
                          flat
                          height="300px"
                          width="530px"
                        >
                          <span class="red--text">
                            <v-row align="center" justify="center">
                              <span class="red--text text-subtitle-1">
                                <v-icon
                                  height="20"
                                  color="red"
                                  class="d-inline-block mt-n1"
                                >
                                  mdi-alert-circle-outline
                                </v-icon>
                                {{ $t('message.videoDoesNotExist') }}
                              </span>
                            </v-row>
                          </span>
                        </v-card>
                      </span>
                      <template v-else>
                        <template v-if="konva.file && konva.img.image">
                          <div class="konva__container">
                            <v-stage
                              ref="stage"
                              class="konva__stage"
                              :config="konva.stage"
                              @mousedown="updateTransformer"
                              @touchstart="updateTransformer"
                            >
                              <v-layer ref="layer">
                                <v-image
                                  :config="konva.img"
                                  @dragend="handleTransformEnd"
                                  @transformend="handleTransformEnd"
                                />
                                <v-transformer ref="transformer" />
                              </v-layer>
                            </v-stage>
                            <span
                              class="konva__player"
                              v-html="embedPage()"
                              v-if="!isExternalSourceVideo"
                            />
                            <div
                              class="external__player"
                              :id="`pandaexternal-${video.video_external_id}`"
                              v-html="embedPage()"
                              v-else
                            ></div>
                          </div>
                        </template>
                        <span
                          v-else-if="!isExternalSourceVideo"
                          v-html="embedPage()"
                        />
                        <div
                          class="external__player"
                          :id="`pandaexternal-${video.video_external_id}`"
                          v-html="embedPage()"
                          v-else
                        ></div>
                      </template>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="11"
                    v-if="
                      video.playable &&
                      video.status != 'CONVERTED' &&
                      video.status != 'BLOCKED'
                    "
                  >
                    <v-alert
                      color="backgroundAlert"
                      dense
                      flat
                      class="mb-0 my-2 ml-1"
                    >
                      <v-row no-gutters justify="space-between" align="center">
                        <span class="body-2">
                          <v-icon class="mr-1">mdi-information</v-icon>
                          {{ $t('message.pages.video.alreadyPlayable') }}
                        </span>
                      </v-row>
                    </v-alert>
                  </v-col>
                  <v-col
                    cols="11"
                    class="py-5 ml-1 container-title-description align-center"
                    v-if="video.original_lang"
                    :class="{ hide: PandaPlayerIsNotReady }"
                  >
                    <div class="d-flex justify-end align-center">
                      <span class="pb-1"
                        >{{ $i18next.t('message.ai.originalLang') }}:</span
                      >
                      <CountryFlag
                        class="flag"
                        size="small"
                        :country="getCountryCodeBySrcLang(video.original_lang)"
                      />
                    </div>
                  </v-col>
                  <v-col
                    v-else
                    cols="11"
                    class="py-8 align-center"
                    style="margin-bottom: 4px"
                    :class="{ hide: PandaPlayerIsNotReady }"
                  >
                  </v-col>
                  <v-col
                    cols="11"
                    class="pt-0 ml-1 pb-2 container-title-description"
                    :class="{ hide: isLoading }"
                  >
                    <template v-if="video.status === 'BLOCKED'">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        class="d-flex red--text ml-2 noIbar caption"
                      >
                        <v-icon size="18" color="red">
                          mdi-alert-circle-outline
                        </v-icon>
                        <span class="ml-1" style="margin-top: 1px">
                          {{ $t('message.blocked') }}
                        </span>
                      </span>
                    </template>
                    <v-text-field
                      v-model="video.title"
                      :placeholder="$t('message.addTitle')"
                      :rules="[
                        rules.required,
                        rules.maxLength,
                        rules.minLength,
                      ]"
                      @focus="inputBeingEdited('title')"
                      @blur="handleEdit"
                      :class="{
                        inputActive: 'title' === activeInput,
                      }"
                      required
                      color="primary"
                      outlined
                      ref="title"
                      @keyup.enter="handleEdit"
                      @keyup.escape="cancelEdit"
                    >
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              @click="cancelEdit"
                            >
                              mdi-close
                            </v-icon>
                          </template>
                          <span>
                            {{ $t('message.pages.video.cancel') }}
                          </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              @click="handleEdit"
                            >
                              mdi-check
                            </v-icon>
                          </template>
                          <span>
                            {{ $t('message.pages.video.save') }}
                          </span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="11"
                    class="py-2 ml-1 container-title-description"
                    :class="{ hide: isLoading }"
                  >
                    <v-textarea
                      v-model="video.description"
                      :placeholder="$t('message.videoDescription')"
                      outlined
                      dense
                      color="primary"
                      auto-grow
                      @focus="inputBeingEdited('description')"
                      @blur="handleEdit"
                      :class="{ inputActive: 'description' === activeInput }"
                      ref="description"
                      hide-details
                      @keyup.enter="handleEdit"
                      @keyup.escape="cancelEdit"
                    >
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              @click="cancelEdit"
                            >
                              mdi-close
                            </v-icon>
                          </template>
                          <span>
                            {{ $t('message.pages.video.cancel') }}
                          </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              @click="handleEdit"
                            >
                              mdi-check
                            </v-icon>
                          </template>
                          <span>
                            {{ $t('message.pages.video.save') }}
                          </span>
                        </v-tooltip>
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-col>
              <v-col :cols="isMobileBreakpoint ? '12' : '6'" class="mt-3">
                <v-row
                  :class="
                    isMobileBreakpoint
                      ? 'mb-5 mx-1 bottom-navigation-playerConfig'
                      : 'mb-5 ml-3 mr-2 bottom-navigation-playerConfig'
                  "
                  style="border-bottom: 1px solid #66666659"
                >
                  <!-- tabs -->
                  <v-bottom-navigation
                    v-model="value"
                    class="background"
                    color="#3e50f7"
                    style="justify-content: left; box-shadow: none"
                    ref="buttonNavigation"
                    grow
                  >
                    <!-- tabs::player -->
                    <v-btn :data-intro="$t('message.introJS.videoPage.player')">
                      <span style="font-size: 16px">{{
                        $t('message.pages.video.player')
                      }}</span>
                    </v-btn>

                    <!-- tabs::analytics -->
                    <v-btn
                      :data-intro="$t('message.introJS.videoPage.metrics')"
                      @click="handleOpenConfirmMetrics"
                    >
                      <span style="font-size: 16px">{{
                        $t('message.pages.video.metrics')
                      }}</span>
                    </v-btn>
                  </v-bottom-navigation>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pa-0">
                    <!-- tab::player -->
                    <v-scroll-x-transition mode="out-in" hide-on-leave>
                      <v-card
                        v-if="value === 0"
                        flat
                        tile
                        class="d-flex flex-column"
                      >
                        <video-player
                          :isExternalSourceVideo="isExternalSourceVideo"
                          :handlePlayerSelection="
                            handleUpdateOldPlayerSelection
                          "
                          :oldPlayerSelection="oldPlayerSelection"
                          :hasEdit="hasEdit"
                        />
                      </v-card>
                    </v-scroll-x-transition>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="!isLoading" no-gutters justify="end">
              <v-col v-if="errors.failedToUpdateVideo" cols="6">
                <v-card
                  height="25"
                  class="d-flex flex-row justify-end align-center"
                  flat
                >
                  <span class="red--text caption align-text justify-end">
                    <v-icon color="red" size="16" class="pb-1">
                      mdi-alert-circle
                    </v-icon>
                    {{ $t('message.errors.networkError') }}
                    {{ networkErrorMsg }}
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
          <form
            ref="downloadForm"
            method="post"
            :action="downloadUrl"
            style="display: none"
          >
            <input
              ref="downloadInput"
              name="Authorization"
              :value="authToken"
              type="hidden"
            />
          </form>
        </v-col>
      </v-row>

      <!-- dialogs -->
      <duplicate-video-modal
        :openModal="openDuplicateVideoModal"
        :videoId="videoId"
        :goToDuplicatedVideo="true"
        @close="openDuplicateVideoModal = false"
      />
      <embed-video
        v-if="showMenuEmbed"
        :startTime="startTime"
        :timeVideo="timeVideo"
        :videoId="videoId"
        :showMenuEmbed="showMenuEmbed"
        :embedSelected="embedSelected"
        :showMenuPosition="menuPosition"
        :fetching="isLoading"
        :video="video"
        :isExternalSourceVideo="isExternalSourceVideo"
        @start-time="startTime = $event"
        @showEmbed="(val) => (showMenuEmbed = val)"
        @embed="handleEmbedEmit"
        @playOpensFullscreen="handlePlayOpensFullscreen"
        @preloadEmbed="preloadEmbed = $event"
      />
      <performance-modal
        :video="video"
        :showMenuPerformance="showMenuPerformance"
        :showMenuPosition="menuPosition"
        :isExternalSourceVideo="isExternalSourceVideo"
        @showPerformance="(val) => (showMenuPerformance = val)"
      />
      <v-menu
        v-if="!isExternalSourceVideo"
        v-model="showMenuLink"
        max-width="450px"
        min-width="450px"
        :position-x="menuPosition.x"
        :position-y="menuPosition.y"
        absolute
        offset-y
        :close-on-content-click="false"
      >
        <v-card class="pa-7">
          <v-row no-gutters>
            <v-col cols="12" class="py-0">
              <h3 style="font-weight: 500">
                {{ $t('message.pages.video.copyHLS') }}
              </h3>
              <v-text-field
                v-model="video.video_hls"
                outlined
                dense
                hide-details
                readonly
                label="URL Playlist HLS"
                required
                @focus="$event.target.select()"
                color="primary"
                @click:append="handleShowLink(video.video_hls)"
                class="mt-4"
              >
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click="handleShowLink(video.video_hls)"
                      >
                        mdi-content-copy
                      </v-icon>
                    </template>
                    <span>
                      {{
                        isCopied
                          ? $t('message.pages.videoEditModal.copied')
                          : $t('message.pages.videoEditModal.copyToClipboard')
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-text-field>
              <a
                class="d-block mt-4"
                style="font-weight: 500; text-decoration: none"
                target="_blank"
                :href="privacyPageLink"
              >
                {{ $t('message.pages.video.privacyPage') }}
              </a>
            </v-col>
          </v-row>
        </v-card>
      </v-menu>
      <v-menu
        min-width="250"
        close-on-click
        absolute
        offset-y
        :position-x="menuPosition.x"
        :position-y="menuPosition.y"
        :close-on-content-click="!bypassClickCloseMenu"
        :value="showMenu"
        @input="handleInput"
      >
        <v-list dense class="py-0">
          <v-list-item
            v-if="isMobileBreakpoint"
            @click="
              showPerformance($event),
                handleSnackbar($t('message.pages.video.clipboardPerformance')),
                handleShowLink(textMetadata)
            "
          >
            <v-list-item-icon class="mr-3">
              <v-icon>mdi-poll</v-icon>
            </v-list-item-icon>
            <v-list-item-title> Performance </v-list-item-title>
          </v-list-item>
          <v-list-item @click="handleOpenLogs()">
            <v-list-item-icon class="mr-3">
              <v-icon>mdi-history</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ $t('message.pages.historyModal.history') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="handleMoveVideo()" v-if="hasEditVideoPerm">
            <v-list-item-icon class="mr-3">
              <v-icon>mdi-folder-move-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ $t('message.move') }}
            </v-list-item-title>
          </v-list-item>
          <template v-if="!isExternalSourceVideo && hasEditVideoPerm">
            <v-list-item
              @click="openDuplicateVideoModal = true"
              v-if="video.status === 'CONVERTED'"
            >
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-content-duplicate</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $t('message.duplicate')
              }}</v-list-item-title>
            </v-list-item>
            <MenuItemDownload
              v-if="hasEditVideoPerm && !checkIfIsImport(video)"
              :video="video"
              :timeout="1000"
              :video-id="videoId"
              :fetch-on-mount="false"
              :value="showMenu"
              @click.native="bypassClickCloseMenu = true"
              @fetched="bypassClickCloseMenu = false"
              @submit="
                downloadServer = $event.downloadServer
                qualityToBeDownloaded = $event.qualityToBeDownloaded
                $nextTick(() => $refs.downloadForm.submit())
              "
            />
          </template>
          <v-divider />
          <v-list-item @click="handleRemoveItem()" v-if="hasEditVideoPerm">
            <v-list-item-icon class="mr-3">
              <v-icon style="color: #f44336">mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="color: #f44336; padding-top: 3px">
              {{ $t('message.pages.video.remove') }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-dialog v-model="confirmRedirect" max-width="550px">
        <v-card>
          <v-card-title class="text-h5">
            <v-icon class="pr-2" large color="primary">mdi-alert</v-icon>
            {{ $t('message.pages.video.pageAlert.title') }}
            <v-spacer></v-spacer>
            <v-btn icon @click="handleCloseConfirmRedirect">
              >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            {{
              $t(
                `message.pages.video.${
                  confirmRedirectWithChange
                    ? 'pageAlertWithChange'
                    : 'pageAlert'
                }.message`
              )
            }}
          </v-card-text>
          <v-card-text v-if="confirmRedirectWithChange">
            {{ $t('message.pages.video.pageAlertWithChange.confirmMessage') }}
          </v-card-text>
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <base-btn
              class="mr-4"
              type="secondary"
              @click="handleCloseConfirmRedirect"
            >
              {{
                $t(
                  `${
                    confirmRedirectWithChange
                      ? 'message.actions.return'
                      : 'message.close'
                  }`
                )
              }}
            </base-btn>
            <base-btn
              @click="
                confirmRedirect = false
                $router.push({
                  name: 'AnalyticsV2Account',
                  query: {
                    v: video.video_external_id,
                  },
                })
              "
            >
              {{
                confirmRedirectWithChange
                  ? $t('message.actions.discardChanges')
                  : 'ok'
              }}
            </base-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <download-alert-dialog />
    </template>
  </page-view>
</template>

<script>
/* eslint-disable */

// external imports
import { mapActions, mapMutations, mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import { isBefore, subMinutes } from 'date-fns'
import _ from 'lodash'
import CountryFlag from 'vue-country-flag'

// internal imports
import { embedOptions as platformsOfEmbed } from '@/utils/embedOptions.js'
import i18n from '@/translations/lang'
import { ENV_CONFIG, BACKUP_DOWNLOADER_SERVER } from '@/config/envs'
import Storage from '@/utils/Storage'
import embedPageMixin from '@/utils/embedPage.mixin.js'
import embedSelection from '@/utils/embedSelection.mixin.js'
import introMixin from '@/utils/intro.mixin.js'
import calcMegabytesMixin from '@/utils/calcMegabytes.js'
import mutedCustomMixin from '@/utils/mutedCustom.mixin.js'
import downloadUrlMixin from '@/utils/downloadUrl.mixin.js'
import externalSourceVideo from '@/utils/externalSourceVideo.mixin.js'
import langCodesMixin from '@/utils/langCodes.mixin.js'

// API
import videosApi from '@/services/videosApi'
import drmApi from '@/services/drmApi'

// Components
import VideoInfo from './info/VideoInfo.vue'
import VideoPlayer from './player/VideoPlayer.vue'
import LoadingLogo from '@/components/LoadingLogo.vue'
import VideoMetrics from './metrics/VideoMetrics.vue'
import EmbedVideo from '@/components/EmbedVideo.vue'
import PerformanceModal from '@/components/PerformanceModal.vue'
import DuplicateVideoModal from '@/components/DuplicateVideoModal.vue'
import PageView from '@/layout/PageView.vue'
import MenuItemDownload from '@/components/MenuItemDownload.vue'
import DownloadAlertDialog from '@/components/DownloadAlertDialog.vue'

export default {
  components: {
    VideoInfo,
    VideoPlayer,
    LoadingLogo,
    VideoMetrics,
    EmbedVideo,
    PerformanceModal,
    DuplicateVideoModal,
    PageView,
    MenuItemDownload,
    CountryFlag,
    DownloadAlertDialog,
    BaseHeader: () => import('@/components/BaseHeader.vue'),
    BaseBtn: () => import('@/components/BaseBtn.vue'),
  },
  mixins: [
    embedPageMixin,
    embedSelection,
    introMixin,
    calcMegabytesMixin,
    mutedCustomMixin,
    externalSourceVideo,
    downloadUrlMixin,
    langCodesMixin,
  ],
  name: 'VideoPage',
  directives: { mask },
  data: () => ({
    PandaPlayerIsNotReady: true,
    isExternalSourceVideo: false,
    openDuplicateVideoModal: null,
    showMenu: false,
    showMenuEmbed: false,
    showMenuLink: false,
    showMenuPerformance: false,
    menuItem: {},
    embedVideo: {
      width: 720,
      height: 360,
      startTimeCheckbox: false,
      startTime: '',
    },
    startTime: '00:00:00',
    menuPosition: {
      x: 72,
      y: 62,
    },
    currentTime: 0,
    timeVideo: 0,
    fetching: false,
    isLoading: false,
    oldVideo: {},
    isBeta: false,
    video: {
      title: '',
      description: '',
      video_external_id: '',
      id: '',
    },
    videoId: '',
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 255) || i18n.t('message.maximumLengthVideo'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
    errors: {
      failedToUpdateVideo: false,
      videoDoesNotExist: false,
    },
    networkErrorMsg: '',
    unknownError: '',
    embedSelected: '',
    videoCustomSize: false,
    autoplay: false,
    isCopied: false,
    authToken: '',
    value: 0,
    activeInput: null,
    db: null,
    radioActive: 0,
    item: '',
    thumbnailUrl: null,
    date: '',
    downloadServer: '',
    dataBeingReplicated: false,
    playOpensFullscreen: false,
    playOpensFullscreenNative: false,
    drmOptionsIndex: 0,
    refreshVideoTimeout: null,
    introPageKey: 'video-page',
    confirmRedirect: false,
    bypassClickCloseMenu: false,
    qualityToBeDownloaded: null,
    unsavedChanges: true,
    embedIframe: null,
    oldPlayerSelection: 'options',
    hasEdit: [],
    confirmRedirectWithChange: false,
  }),
  provide() {
    return {
      introPageKey: this.introPageKey,
      video: this.video,
    }
  },
  async created() {
    this.isBeta = location.search.match('beta')
    this.authToken = Storage.getItem('accessToken')
    if (!window.db) {
      this.$root.$emit('initDexie')
    }
    this.isLoading = true
    await this.readVideoInfo()
    if (this.video.drm_group_ids && this.video.drm_group_ids.length) {
      await this.signDrmToken()
    }
    this.isLoading = false
    Storage.setItem('width', this.embedVideo.width)
    Storage.setItem('height', this.embedVideo.height)
    let storageEmbedOption = Storage.getItem('embedType')
    let embedOptionsValue = this.embedOptions.map((el) => el.value)
    let storageIndex = embedOptionsValue.indexOf(storageEmbedOption)

    if (storageIndex !== -1) {
      this.embedSelected = this.embedOptions[storageIndex].value
    } else {
      this.embedSelected = this.embedOptions[0].value
    }
    Storage.setItem('embedType', this.embedSelected)
    let pullzoneValue = Storage.getItem(
      `pullzone-${this.$store.state.user.userInfo.sub}`
    )
    this.userPullzoneName = pullzoneValue
    this.handleEmbedSelection()
    this.fetching = false
  },
  async mounted() {
    this.$root.$on('refreshVideoInfo', () => {
      this.readVideoInfo()
    })
    this.$root.$on('defineTimeVideo', (val) => {
      this.timeVideo = this.video.length = val
      this.loadingExternalDuration = false
      this.$root.$emit('updatedExternalTimeVideo')
    })
    this.$root.$on('updateEmbedPreviewChange', () => {
      this.unsavedChanges = true
    })
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState == 'visible') {
        if (
          (this.video.status === 'DRAFT' ||
            this.video.status === 'CONVERTING') &&
          this.$route.name === 'VideoPage'
        ) {
          this.refreshVideoTimeout = setInterval(this.getStatusVideo, 5000)
        }
      } else {
        clearInterval(this.refreshVideoTimeout)
      }
    })
    this.$root.$on(
      'changeEmbed',
      function () {
        this.embedSelected = Storage.getItem('embedType')
          ? Storage.getItem('embedType')
          : i18n.t('message.pages.videoEditModal.embedConfiguration.default')
      }.bind(this)
    )
    this.$root.$on('updateVideoInfo', (video) => (this.video = video))
    this.lessThanThirtyMinutesAgo()
    this.$root.$on('removedVideoInPage', async () => {
      await window.db.videos.delete(this.video.id)
      this.handleBackToListing()
    })
    window.addEventListener('message', (event) => {
      if (!this.profile.colors) return
      const { data } = event
      const { captionsColor, captionsBackgroundColor } = this.profile.colors

      if (data.message === 'panda_timeupdate') {
        this.currentTime = Math.round(data.currentTime)
      }
      if (data.message === 'panda_ready') {
        this.PandaPlayerIsNotReady = false
        const iframe = document.getElementById('panda-player').contentWindow
        iframe.postMessage(
          {
            type: 'colors',
            parameter: {
              colors: {
                primaryColor: this.profile.colors?.primaryColor,
                controlsColor: this.profile.colors?.controlsColor,
                captionsColor: captionsColor,
                captionsBackgroundColor: captionsBackgroundColor,
              },
            },
          },
          '*'
        )
      }
    })
    this.playOpensFullscreen = Storage.getItem('playOpensFullscreen') ?? false
    this.playOpensFullscreenNative =
      Storage.getItem('playOpensFullscreenNative') ?? false

    this.setIntroJS({ key: this.introPageKey })

    this.konva.file = null
    this.konva.anima = null
    this.konva.gif = null
    this.konva.animator = null

    this.konva.id =
      this.$store.state.video.profile?.vsl?.customMutedIndicatorId || null

    this.isBrowserBrave =
      (navigator.brave && (await navigator.brave.isBrave())) || false

    if (this.isBrowserBrave) this.konva.percent = 1
  },
  beforeDestroy() {
    clearInterval(this.refreshVideoTimeout)
    this.refreshVideoTimeout = null
    this.$root.$off('removedVideoInPage')
    this.UPDATE_VIDEO({})
    this.UPDATE_VIDEO_PROFILE({})
    this.UPDATE_PLAYER({})
    this.UPDATE_VIDEO_PROFILE_ID(null)
  },
  watch: {
    value() {
      if (this.hasEdit && this.hasEdit.length > 0)
        this.confirmRedirectWithChange =
          typeof this.hasEdit[0] === 'function'
            ? !this.hasEdit[0]()
            : !this.hasEdit[0]
      if (this.confirmRedirectWithChange) this.value = 0
    },
    controlsColor(value) {
      if (value.toString().match(/#[a-zA-Z0-9]{8}/)) {
        this.controlsColor = value.substr(0, 7)
      }
    },
    radioActive: function () {
      this.radioActive === 1 ? (this.embedSelected = 'general') : ''
    },
    currentTime: function () {
      this.startTime = this.formatTime(this.currentTime, 'startTime')
    },
    startTime: function () {
      let time = this.startTime.split(':')
      let seconds = +time[0] * 60 + +time[1]
      let input = this.startTime
      if (this.timeVideo >= 3600) {
        if (time.length === 2) {
          seconds = +time[0] * 60 + +time[1]
        } else if (time.length === 1) {
          seconds = +time[0]
        } else {
          seconds = +time[0] * 60 * 60 + +time[1] * 60 + +time[2]
        }
      } else {
        if (time.length === 1) {
          seconds = +time[0]
        }
      }
      if (seconds > this.timeVideo) {
        this.embedVideo.startTime = this.timeVideo
        this.startTime = this.formatTime(this.timeVideo, 'startTime')
      }
      this.embedVideo.startTime = seconds
    },
  },
  computed: {
    ...mapState({
      profile: (state) => state.video.profile,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    isExternalSourceNoLengthVideo() {
      if (this.isExternalSourceVideo) {
        if (!this.video.length) {
          return true
        }
      }
      return false
    },
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
    isConvertingTooLazy() {
      if (
        Math.abs(new Date(this.video.updated_at) - new Date()) / 36e5 > 3 &&
        Math.abs(new Date(this.video.updated_at) - new Date()) / 36e5 < 48
      ) {
        return true
      }
      return false
    },
    textMetadata() {
      return `<link rel="prerender" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br/embed/?v=${this.video.video_external_id}">
<link rel="preload" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br/embed/js/hls.js" as="script">
<link rel="preload" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br/embed/js/plyr.polyfilled.min.js" as="script">
<link rel="preload" href="https://config.tv.pandavideo.com.br/${this.video.pullzone_name}/${this.video.video_external_id}.json" as="fetch">
<link rel="preload" href="https://config.tv.pandavideo.com.br/${this.video.pullzone_name}/config.json" as="fetch">
<link rel="preload" href="https://b-${this.video.pullzone_name}.tv.pandavideo.com.br/${this.video.video_external_id}/playlist.m3u8" as="fetch">
<link rel="dns-prefetch" href="https://b-${this.video.pullzone_name}.tv.pandavideo.com.br">
<link rel="dns-prefetch" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br">
<link rel="dns-prefetch" href="https://${this.video.pullzone_name}.b-cdn.net">`
    },
    embedOptions() {
      const [general] = platformsOfEmbed.filter(
        ({ value }) => value === 'general'
      )
      const rest = platformsOfEmbed.filter(({ value }) => value !== 'general')
      const sorted = rest.sort((a, b) => a.value.localeCompare(b.value))

      return [general, ...sorted]
    },
    pageTitle() {
      return this.$i18next.t('message.videos')
    },
    infoPage() {
      if (!this.video.id) return ''
      const locale = this.getLocale()

      const prefix = this.$i18next.t('message.pages.video.pageIndividualInfo')
      const created_at = new Date(this.video.created_at).toLocaleString(
        locale,
        { year: 'numeric', month: '2-digit', day: '2-digit' }
      )
      const size = this.addDecimal(
        this.calcMegabytes(this.video.storage_size, 'B', 'MB', true)
      )
      if (created_at && this.video.status === 'CONVERTED') {
        return `<span>${prefix} ${created_at}</span>${
          this.isExternalSourceVideo && size
            ? ''
            : `<span class="ml-4">${size}</span>`
        }`
      }
    },
    isDomainFromBrazil() {
      return location.host.match(/.com$/) ? false : true
    },
    privacyPageLink() {
      return `https://pandavideo.com${
        this.isDomainFromBrazil ? '.br' : ''
      }/privacy/`
    },
  },
  methods: {
    ...mapActions('video', ['getVideoConfig', 'getVideoProfileId']),
    ...mapMutations('video', [
      'UPDATE_VIDEO',
      'UPDATE_VIDEO_PROFILE',
      'UPDATE_PLAYER',
      'UPDATE_VIDEO_PROFILE_ID',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    checkIfIsImport(video) {
      if (!video.description) return
      const desc = video.description
      let val = desc.includes('hotmart') || desc.includes('vimeo')
      return val
    },
    handleGoToLink(link) {
      window.open(link, '_blank')
    },
    addDecimal(lengthString) {
      let numberPart = lengthString.split(' ')[0]
      let strPart = lengthString.split(' ')[1]

      numberPart = Number(numberPart).toFixed(1)
      return `${numberPart} ${strPart}`
    },
    getLocale() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
      return 'pt-BR'
    },
    changeDrmIndex(value) {
      this.drmOptionsIndex = value
    },
    async signDrmToken() {
      try {
        let ret = await drmApi.signJwtToken(
          this.video.drm_group_ids[0].drm_group_id
        )
        this.signedToken = ret.data.jwt
        return
      } catch (e) {
        console.error(e)
        return
      }
    },
    async readVideoInfo() {
      const videoId = this.$route.params.id
      try {
        let videoInfo = await videosApi.getAVideo(videoId)
        if (videoInfo.data.hasOwnProperty('video_source')) {
          this.isExternalSourceVideo = true
        }
        this.video = videoInfo.data
        this.oldVideo = { ...videoInfo.data }
        if (videoInfo.data.description === null) {
          this.video.description = ''
          this.oldVideo.description = ''
        }
        this.timeVideo = this.oldVideo.length
        this.videoId = videoInfo.data.id
        this.video.video_external_id = videoInfo.data.video_external_id
        if (
          this.video.status === 'DRAFT' ||
          this.video.status === 'CONVERTING'
        ) {
          this.refreshVideoTimeout = setInterval(this.getStatusVideo, 5000)
        }
        this.UPDATE_VIDEO(this.video)
        if (this.video.config.profile) {
          await this.getVideoProfileId(this.video.config.profile)
        }
      } catch (error) {
        this.errors.videoDoesNotExist = true
      }
    },
    async handleEdit() {
      this.errors.failedToUpdateVideo = false
      this.networkErrorMsg = ''
      this.activeInput = ''
      let videoObj = {}
      if (this.video.title !== this.oldVideo.title) {
        videoObj['title'] = this.video.title.trim()
      } else if (this.video.description !== this.oldVideo.description) {
        videoObj['description'] = this.video.description.trim()
      } else {
        return
      }
      if (this.video.title.length < 3) {
        return
      }
      this.fetching = true
      try {
        const apiVideo = videoObj
        let ret = await videosApi.updateVideo({ ...apiVideo }, this.videoId)
        let dbUpdateObject = { title: ret.data.title }
        if (ret.data.description) {
          dbUpdateObject['description'] = ret.data.description
        }
        await window.db.videos.update(ret.data.id, dbUpdateObject)
        this.oldVideo = ret.data
        this.video.folder_id
          ? this.$root.$emit('folderEditVideo', ret.data)
          : this.$root.$emit('rootEditVideo', ret.data)
        this.handleSnackbar()
      } catch (e) {
        this.networkErrorMsg = e.response.data.errMsg
        this.errors.failedToUpdateVideo = true
      }
      this.fetching = false
    },
    async handleDeleteVideo() {
      let videos = []
      videos.push(this.video)
      this.$root.$emit('deleteVideoModal', [...videos])
    },
    async getStatusVideo() {
      const { data: video } = await videosApi.getAVideo(this.$route.params.id)

      if (video.status !== 'DRAFT' && video.status !== 'CONVERTING') {
        clearInterval(this.refreshVideoTimeout)
        this.$root.$emit('updateVideoInListing', this.video)
        this.video.status = video.status
      }
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
    lessThanThirtyMinutesAgo() {
      setTimeout(() => {
        this.lessThanThirtyMinutesAgo()
      }, 4000)
      this.dataBeingReplicated = isBefore(
        subMinutes(new Date(), 30),
        new Date(this.profile.updated_at)
      )
      return this.dataBeingReplicated
    },
    inputBeingEdited(i, ref) {
      this.activeInput = i
      if (ref) {
        this.activeInput = i + ref
      }
    },
    inputEndEdited() {
      this.activeInput = ''
    },
    cancelEdit() {
      this.$refs.title.blur()
      this.$refs.description.blur()
      if (this.video.title !== this.oldVideo.title) {
        this.video.title = this.oldVideo.title
        this.$refs.title.blur()
      } else if (this.video.description !== this.oldVideo.description) {
        this.video.description = this.oldVideo.description
        this.$refs.description.blur()
      }
    },
    getRecuoModal(size) {
      const innerWindowWidth = window.innerWidth
      let recuo = innerWindowWidth - size

      if (recuo < 0) recuo = 0

      return recuo
    },
    showDots() {
      this.menuPosition.x = this.getRecuoModal(150)

      this.showMenu = false
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    showEmbed() {
      this.menuPosition.x = this.getRecuoModal(600)

      this.showMenuEmbed = false
      this.$nextTick(() => {
        this.showMenuEmbed = true
      })
    },
    showPerformance() {
      this.menuPosition.x = this.getRecuoModal(600)

      this.showMenuPerformance = false
      this.$nextTick(() => {
        this.showMenuPerformance = true
      })
    },
    showLink() {
      this.menuPosition.x = this.getRecuoModal(450)

      this.$nextTick(() => {
        this.showMenuLink = true
      })
    },
    formatTime(seconds, type) {
      const h = Math.floor(seconds / 3600)
      const m = Math.floor((seconds % 3600) / 60)
      const s = Math.round(seconds % 60)
      if (type) {
        0
        if (this.timeVideo >= 3600) {
          return [
            h > 9 ? h : h ? '0' + h : '0' + h || '00',
            m > 9 ? m : h ? '0' + m : '0' + m || '00',
            s > 9 ? s : '0' + s,
          ]
            .filter(Boolean)
            .join(':')
        } else {
          return [
            m > 9 ? m : h ? '0' + m : '0' + m || '00',
            s > 9 ? s : '0' + s,
          ]
            .filter(Boolean)
            .join(':')
        }
      }
      return [
        h > 9 ? h : h ? '0' + h : '0' + h || '00',
        m > 9 ? m : h ? '0' + m : '0' + m || '00',
        s > 9 ? s : '0' + s,
      ]
        .filter(Boolean)
        .join(':')
    },
    handleMoveVideo() {
      this.$root.$emit('moveModal', [this.$store.state.user.routedVideo])
    },
    handleRemoveItem() {
      this.$root.$emit('deleteVideoModal', [this.$store.state.user.routedVideo])
    },
    hasHistory() {
      return window.history.length > 2
    },
    handleBackToListing() {
      const videoFolderId = this.video.folder_id
      if (videoFolderId && videoFolderId != 'root') {
        this.$router
          .push({ name: 'Folders', params: { id: videoFolderId } })
          .catch(() => {})
        return
      }
      if (videoFolderId === 'root') {
        this.$router.push({ name: 'Videos' }).catch(() => {})
        return
      }
      if (this.hasHistory()) {
        this.$router.go(-1)
        return
      }
      this.$router.push({ name: 'Videos' }).catch(() => {})
    },
    handleShowLink(item) {
      this.isCopied = true
      navigator.clipboard.writeText(`${item}`)
      setTimeout(() => {
        this.isCopied = false
      }, 3000)
    },
    handleCopyContent(value) {
      navigator.clipboard.writeText(`${value}`)
    },
    handleEmbedEmit(embed) {
      this.handleSnackbar(this.$t('message.embedCopiedLink'))
      this.handleShowLink(embed)
    },
    handlePlayOpensFullscreen({ script, native }) {
      this.playOpensFullscreen = script
      this.playOpensFullscreenNative = native
    },
    handleOpenLogs() {
      this.$root.$emit('openModalItemLogs', this.video)
    },
    handleInput(event) {
      if (!this.bypassClickCloseMenu) {
        this.showMenu = event
      }
    },
    embedPage() {
      if (this.unsavedChanges) {
        this.embedIframe = this.embedPageGet()
        this.unsavedChanges = false
      }

      if (!this.embedIframe) {
        this.embedIframe = this.embedPageGet()
      }
      return this.embedIframe
    },
    handleUpdateOldPlayerSelection(option) {
      this.oldPlayerSelection = option
    },
    handleCloseConfirmRedirect() {
      this.confirmRedirect = false
      this.value = 0
      this.confirmRedirectWithChange = false
      this.handleAlterSelectVBtn(0, true)
      this.handleAlterSelectVBtn(1, false)
    },
    handleAlterSelectVBtn(index, activeButton) {
      this.$refs.buttonNavigation.$children[0].$children[index].classes[
        'v-btn--active'
      ] = activeButton
    },
    handleOpenConfirmMetrics() {
      this.confirmRedirect = true
      this.value = 1
    },
  },
}
</script>

<style lang="scss" scoped>
.hide {
  display: none;
}
.flag {
  border-radius: 4px;
  margin: -16px 0 0 -24px !important;
  transform: scale(0.44) translateX(60%) translateY(38%) !important;
  -ms-transform: scale(0.44) translateX(60%) translateY(38%) !important;
  -webkit-transform: scale(0.44) translateX(60%) translateY(38%) !important;
  -moz-transform: scale(0.44) translateX(60%) translateY(38%) !important;
}

.konva {
  &__container {
    position: relative;
  }

  &__stage {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    width: 100%;
    height: 100%;
  }

  &__player {
    pointer-events: none;
  }
}

.external__player {
  position: relative;
  padding: 56.25% 0 0;
  width: 100%;
  height: 100%;
}
</style>

<style>
.optionsText {
  font-weight: 400;
  margin: 0 0 0 5px !important;
  letter-spacing: normal;
  padding: 2px 0;
}
.container-title-description .v-text-field--outlined fieldset,
.container-title-description .v-input__slot .v-input__append-inner {
  display: none;
}

.container-title-description .inputActive fieldset,
.inputActive .v-input__slot .v-input__append-inner,
.inputActive .v-textarea .v-input__append-inner {
  display: block !important;
}

.container-title-description .v-input__slot:hover {
  background: #3e50f740 !important;
}

.container-title-description
  .inputActive
  .v-input__control
  .v-input__slot:hover {
  background: transparent !important;
}

.container-title-description .v-text-field input {
  font-size: 1.2em;
  font-weight: 500;
}

.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}

.embed-textarea .v-text-field__slot {
  margin: 0 -47px 4px 0 !important;
}

.performance-textarea .v-text-field__slot {
  margin: 0 -47px 4px 0 !important;
}

.defaultThumb {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.headerTitle {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.08em;
}

.cardTitle {
  font-weight: 600;
  font-size: 28px;
  line-height: 150%;
}

.embed-textarea .v-text-field__slot {
  margin: 0 -47px 4px 0 !important;
}

.cardSubtitle {
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.08em;
  color: #878787;
}

.icon-container {
  background-color: #eaedf6;
  padding: 4px;
  border-radius: 3px;
}

.videoCardTitle {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #2f2f2f;
}

.cardElevation {
  box-shadow: 0px 5px 20px rgba(18, 25, 43, 0.06) !important;
  border-radius: 20px !important;
}

.wrapText {
  word-break: break-word;
}
.menuText {
  font-weight: 400;
  margin: 0 0 0 5px !important;
  letter-spacing: normal;
  font-family: 'Rubik', sans-serif !important;
  padding: 2px 0;
}
.bottom-navigation-playerConfig
  .v-item-group.v-bottom-navigation
  .v-btn.v-btn--active {
  border-bottom: 2px solid #6366f7;
}

.icon-accordion {
  order: 0;
}

.header-accordion {
  order: 1;
}

:root {
  --plyr-color-main: #fafafa;
  --plyr-captions-text-color: #fafafa;
  --plyr-captions-background: #fafafa;
  --plyr-video-control-color: #fafafa;
  --plyr-captions-text-color: #fafafa;
}

.button-choose-cta {
  width: 100%;
}

.button-choose-cta span {
  width: 100%;
  float: left;
  text-align: left;
  display: block;
}

.button-choose-cta span i {
  float: right;
}
@media (max-width: 1076px) {
  #update-changes {
    display: none;
  }
}
</style>
